const simpleSorting = {
  component: 'filter-pane-sorting',
  classification: {
    section: 'sorting',
    tags: ['simple'],
    exclusive: true,
  },
};

export default simpleSorting;
